import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import AttachedDocumentsTable from './detailTables/AttachedDocumentsTable';
import AttachedVideosTable from './detailTables/AttachedVideosTable';

const AttachedDocumentsAndVideosTab = ({ claimId }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="attached-documents-videos-subtabs">
            <TabPanel
                header={
                    <span>
                        <i className="pi pi-file mr-2" />
                        Dokümanlar
                    </span>
                }
            >
                <AttachedDocumentsTable claimId={claimId} />
            </TabPanel>
            <TabPanel
                header={
                    <span>
                        <i className="pi pi-video mr-2" />
                        Ekli Videolar
                    </span>
                }
            >
                <AttachedVideosTable claimId={claimId} />
            </TabPanel>
        </TabView>
    );
};

export default AttachedDocumentsAndVideosTab;
